/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import withStyles from '@material-ui/core/styles/withStyles';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';

/**
 * @class
 * @extends React.Component
 */
class NotificationTypeFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilter } = props;
    this.state = {
      id: (appliedFilter && appliedFilter.id) || '',
      name: (appliedFilter && appliedFilter.name) || '',
      category: (appliedFilter && appliedFilter.category) || '',
      isActive:
        appliedFilter && appliedFilter.isActive !== undefined
          ? appliedFilter.isActive
          : null,
      localFilter: appliedFilter || null,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   * @returns {*} - No returns value.
   */
  handleChangeFilter = changedFilter => {
    const { localFilter } = this.state;
    const { filter } = this.props;
    const filters = { ...localFilter, ...changedFilter };
    this.setState({ localFilter: filters });
    filter(filters);
  };

  /**
   * @description
   * Handle change in id filter.
   *
   * @param {Object} event - Input change event.
   * @returns {undefined} No return.
   */
  handleIdChange = event => {
    const id = event.target.value;
    this.setState({ id });
    this.handleChangeFilter({ id: id || undefined });
  };

  /**
   * @description
   * Handle change in name filter.
   *
   * @param {Object} event - Input change event.
   * @returns {undefined} No return.
   */
  handleNameChange = event => {
    const name = event.target.value;
    this.setState({ name });
    this.handleChangeFilter({ name: name || undefined });
  };

  /**
   * @description
   * Handle change in category filter.
   *
   * @param {Object} event - Input change event.
   * @returns {undefined} No return.
   */
  handleCategoryChange = event => {
    const category = event.target.value;
    this.setState({ category });
    this.handleChangeFilter({
      category: category || undefined,
    });
  };

  /**
   * @description
   * Handle change in isActive filter.
   *
   * @returns {undefined} No return.
   */
  handleIsActiveChange = () => {
    const { isActive } = this.state;
    let newValue;
    if (isActive === null) {
      newValue = true;
    } else if (isActive) {
      newValue = false;
    } else {
      newValue = null;
    }
    this.setState({ isActive: newValue });
    this.handleChangeFilter({
      isActive: newValue === null ? undefined : newValue,
    });
  };

  /**
   * @description
   * Clear all filters.
   *
   * @returns {undefined} No return.
   */
  handleClearFilter = () => {
    const { filter } = this.props;
    this.setState({
      id: '',
      name: '',
      category: '',
      isActive: null,
      localFilter: null,
    });
    filter({});
  };

  /**
   * @description
   * Render component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { classes, t } = this.props;
    const { id, name, category, isActive } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            id="filter-id"
            label={t('notification_type.filters.id')}
            fullWidth
            value={id}
            onChange={this.handleIdChange}
            className={classes.textField}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            id="filter-name"
            label={t('notification_type.filters.name')}
            fullWidth
            value={name}
            onChange={this.handleNameChange}
            className={classes.textField}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={2}>
          <TextField
            id="filter-category"
            label={t('notification_type.filters.categoryId')}
            type="number"
            fullWidth
            value={category}
            onChange={this.handleCategoryChange}
            className={classes.textField}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={2}>
          <FormControlLabel
            control={
              <Checkbox
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                }}
                checked={isActive === true}
                indeterminate={isActive === null}
                onChange={this.handleIsActiveChange}
              />
            }
            label={t('notification_type.filters.isActive')}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={2}>
          <Button
            color="white"
            onClick={this.handleClearFilter}
            className={classes.clearButton}
          >
            {t('common.clearFilters')}
          </Button>
        </GridItem>
      </GridContainer>
    );
  }
}

/**
 * NotificationTypeFilter PropTypes
 */
NotificationTypeFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  filter: PropTypes.func.isRequired,
  appliedFilter: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    category: PropTypes.string,
    isActive: PropTypes.bool,
  }),
};

NotificationTypeFilter.defaultProps = {
  appliedFilter: null,
};

export default withTranslation()(
  withStyles(FilterStyles)(NotificationTypeFilter),
);
